<template>
  <!--弹框3 开始-->
  <el-dialog :visible.sync="framePaymentFailDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/fail.png" class="frame-big-img"></div>
      <div class="frame-text-hotel-sold wordBreak">
        {{$t('paymentFailPopUp')}}
      </div>
      <div class="frame-text-hotel-sold wordBreak" style="margin: 10px 0px; font-size: 14px;">
        {{$t('paymentFailDesc')}}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-goback" @click="retryClick">{{$t('retry')}}</el-button>
    </span>
  </el-dialog>
  <!--弹框3 结束-->
  <!--引入方式-->
  <!-- <framePaymentFail :framePaymentFailDialog="framePaymentFailDialog"></framePaymentFail> -->
</template>

<script>
export default {
  name: 'framePaymentFail',
  props: ['framePaymentFailDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: '',
      cityname: '',
      language: this.common.languageSet(this),
      hotelname: '',
      source: 'roompai'
    }
  },
  watch: {
    language: function (newCur, oldCur) {
    }
  },
  created () {},
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
  },
  methods: {
    retryClick: function () {
      this.$emit('paymentRetryClick', 0)
    }
  }
}
</script>

<style scoped>
.textcenter{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:20px; font-size: 16px;color: #4F4C4C;text-align: center;}
.dialog-goback{width: auto; border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;font-weight: 500;font-size: 14px;background-color: rgba(79, 76, 76, 1); color:#FFFFFF;cursor:pointer;padding: 12px 40px;}
.dialog-goback:hover{background-color: #FFFFFF; color: rgba(79, 76, 76, 1); }
.textcenter /deep/ .el-dialog{background-position: right bottom; background-color: #fff;background-size: 23%;}
@media screen and (max-width: 1000px) {
.dialog-goback{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/framePaymentFail.vue